"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaylinkToJSON = exports.PaylinkFromJSONTyped = exports.PaylinkFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function PaylinkFromJSON(json) {
    return PaylinkFromJSONTyped(json, false);
}
exports.PaylinkFromJSON = PaylinkFromJSON;
function PaylinkFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
        'error': !(0, runtime_1.exists)(json, 'error') ? undefined : (0, _1.PaylinkErrorFromJSON)(json['error']),
    };
}
exports.PaylinkFromJSONTyped = PaylinkFromJSONTyped;
function PaylinkToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'url': value.url,
        'error': (0, _1.PaylinkErrorToJSON)(value.error),
    };
}
exports.PaylinkToJSON = PaylinkToJSON;
//# sourceMappingURL=Paylink.js.map